import React from 'react';
import MarkerPoint from './component';

export default React.memo(MarkerPoint);
